import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance';
import { useMutation, useQueryClient } from 'react-query';
import { BaseError } from '@utils/types/shared/base';
import { POST_URL } from '@utils/api/endpoints';

type CreateSubscriptionPlanRequest = {
  customer_id: number;
  auto_renew: boolean;
  plan_id: number;
};

export const useCreateSubscriptionPlan = () => {
  const queryClient = useQueryClient();

  const createSubscriptionPlan = async (
    requestData: CreateSubscriptionPlanRequest
  ) => {
    const { plan_id, ...restData } = requestData;
    const response = await Axios.post(
      POST_URL(plan_id.toString()).createSubscriptionPlan,
      restData
    );

    return response.data;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<any, AxiosError<BaseError>, CreateSubscriptionPlanRequest>(
    createSubscriptionPlan,
    {
      onSuccess: () => {
        queryClient.invalidateQueries('reseller-subscriptions');
      },
      onError: () => {
        // Let the component handle the error
      },
      useErrorBoundary: false
    }
  );
};
